"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _commonMedia = _interopRequireDefault(require("../styles/common-media.css"));
/**
 * ## YoutubeVideo - component
 *
 * Video Player 1 is a very basic component that takes a youtube video ID and creates a full width video
 */
var YoutubeVideo = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(YoutubeVideo, _React$Component);
  function YoutubeVideo() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = YoutubeVideo.prototype;
  _proto.getYoutubeURL = function getYoutubeURL(youtubeVideoId) {
    return "https://www.youtube.com/embed/" + youtubeVideoId + "?modestbranding=1&rel=0";
  };
  _proto.render = function render() {
    var _this$props = this.props,
      youtubeVideoId = _this$props.youtubeVideoId,
      classes = _this$props.classes,
      market = _this$props.market;
    var isCA = market === 'ca';
    var iframeClasses = (0, _clsx["default"])(_commonMedia["default"].videoIframe, classes, {
      'optanon-category-C0001': isCA
    });
    return /*#__PURE__*/_react["default"].createElement("iframe", {
      title: "YouTube video player",
      className: iframeClasses,
      frameBorder: "0",
      "data-src": isCA ? this.getYoutubeURL(youtubeVideoId) : '',
      src: !isCA ? this.getYoutubeURL(youtubeVideoId) : ''
    });
  };
  return YoutubeVideo;
}(_react["default"].Component);
exports["default"] = YoutubeVideo;
YoutubeVideo.displayName = 'YoutubeVideo';
YoutubeVideo.defaultProps = {
  youtubeVideoId: '',
  market: ''
};